(function () {

  'use strict';

  function printerQueueAccordion(Utils, PrinterListService,
    $filter, TenantListService, $location, URLS, URL_PARAMS, PrinterQueueAccordionService) {
    return {
      restrict: 'EA',
      scope: {
        queues: '=queues',
        printer: '=parentElement',
        close: '&',
      },
      templateUrl: 'app/directives/queueDirective/printer-queue-accordion.template.html',
      link: function (scope, element, attrs) {

        scope.ifGroups = PrinterQueueAccordionService.isGroupsEnabled(scope.queues);

      }
    };
  }
  printerQueueAccordion.$inject = ['Utils', 'PrinterListService',
    '$filter', 'TenantListService', '$location', 'URLS', 'URL_PARAMS', 'PrinterQueueAccordionService'
  ];

  angular
    .module('printix-admin')
    .directive('printerQueueAccordion', printerQueueAccordion);

})();